import { parse, stringify } from 'lossless-json';

// TODO: this is hardcoded sample self delclaration and actual txn object
export const SELF_DECLARED_VALUES = {
    "Average_Balance": 140000,
    "Number_Of_Monthly_Ach_Deposits": 5,
    "Amount_Of_Monthly_Ach_Deposits": 125000,
    "Number_Of_Monthly_Domestic_Wire_Deposits": 7,
    "Amount_Of_Monthly_Domestic_Wire_Deposits": 125000,
    "Number_Of_Monthly_International_Wire_Deposits": 6,
    "Amount_Of_Monthly_International_Wire_Deposits": 125000,
    "Number_Of_Monthly_Ach_Payments": 3,
    "Amount_Of_Monthly_Ach_Payments": 125000,
    "Number_Of_Monthly_Domestic_Wire_Payments": 5,
    "Amount_Of_Monthly_Domestic_Wire_Payments": 125000,
    "Number_Of_Monthly_International_Wire_Payments": 4,
    "Amount_Of_Monthly_International_Wire_Payments": 125000,
    "Number_Of_Monthly_Stablecoin_Conversions_Deposits": 12,
    "Amount_Of_Monthly_Stablecoin_Conversions_Deposits": 20000,
    "Number_Of_Monthly_Stablecoin_Conversions_Payments": 4,
    "Amount_Of_Monthly_Stablecoin_Conversions_Payments": 5000,
    "Count_Of_Monthly_Cryptocurrency_Conversions": 2,
    "Amount_Of_Monthly_Cryptocurrency_Conversions": 20000,
}

export const ACTUAL_TXN = {
    "Average_Balance": 150000,
    "Number_Of_Monthly_Ach_Deposits": 5,
    "Amount_Of_Monthly_Ach_Deposits": 105000,
    "Number_Of_Monthly_Domestic_Wire_Deposits": 10,
    "Amount_Of_Monthly_Domestic_Wire_Deposits": 150000,
    "Number_Of_Monthly_International_Wire_Deposits": 5,
    "Amount_Of_Monthly_International_Wire_Deposits": 225000,
    "Number_Of_Monthly_Ach_Payments": 4,
    "Amount_Of_Monthly_Ach_Payments": 100000,
    "Number_Of_Monthly_Domestic_Wire_Payments": 2,
    "Amount_Of_Monthly_Domestic_Wire_Payments": 100000,
    "Number_Of_Monthly_International_Wire_Payments": 1,
    "Amount_Of_Monthly_International_Wire_Payments": 15000,
    "Number_Of_Monthly_Stablecoin_Conversions_Deposits" : 10,
    "Amount_Of_Monthly_Stablecoin_Conversions_Deposits" : 10000,
    "Number_Of_Monthly_Stablecoin_Conversions_Payments" : 8,
    "Amount_Of_Monthly_Stablecoin_Conversions_Payments" : 10000,
    "Count_Of_Monthly_Cryptocurrency_Conversions": 0,
    "Amount_Of_Monthly_Cryptocurrency_Conversions": 50000,
}

export const CONVERSIONS_FIELD_MAP = {
    hasCoinConversionPlan: "'Plan on Converting Stablecoins'",
    hasCryptoConversionPlan: "'Plan on Converting Cryptocurrencies'"
}

export const formatJson = obj => {
    try {
        return stringify(obj, null, 2); // still prints 50.0
    } catch (err) {
        return String(obj);
    }
};
